import commonFunc from '@/common/commonFunction';

import { defaultDictionaryState } from './module-dictionary-state';

export default {
	resetState(state) {
		Object.assign(state, defaultDictionaryState);
	},
	updateProvinceList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.ProvinceList.removeAll();
		state.ProvinceList.append(res.Data);
	},
	updateDistrictList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.DistrictList.removeAll();
		state.DistrictList.append(res.Data);
	},
	updateWardList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.WardList.removeAll();
		state.WardList.append(res.Data);
	},
	updateTaxAgencyList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.TaxAgencyList.removeAll();
		state.TaxAgencyList.append(res.Data);
	},
	updateAllTaxAgencyList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.AllTaxAgencyList.removeAll();
		state.AllTaxAgencyList.append(res.Data);
	},
	updateTreasuryList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.TreasuryList.removeAll();
		state.TreasuryList.append(res.Data);
	},
	updateTreasuryBankList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.TreasuryBankList.removeAll();
		state.TreasuryBankList.append(res.Data);
	},
	/**
	 * Cập nhật danh sách mã chương theo quy định
	 */
	updateChapterList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.ChapterList.removeAll();
		state.ChapterList.append(res.Data);
	},
	/**
	 * Cập nhật danh sách nội dung kinh tế
	 */
	updateEconomicsList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.EconomicsList.removeAll();
		state.EconomicsList.append(res.Data);
	},

	/**
	 * Cập nhật danh sách ngân hàng phục vụ cho nộp thuế điện tử
	 */
	updateBankList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.BankList.removeAll();
		state.BankList.append(res.Data);
	},

	updateGetServey(state, res) {
		state.ShowServey = true;
	},

	updateAdminProcedureList(state, res) {
		commonFunc.genVKeyValue(res.Data);
		state.AdminProcedureList.removeAll();
		state.AdminProcedureList.append(res.Data);
	}
};
